
// 当前 host
const HOST = window.location.host

const protocol=window.location.protocol

// 开发
const DEV = 'DEV'

// 生产
const PROD = 'PROD'

// 当前环境
const ENV = HOST === 'localhost:8080' ? DEV : PROD

// 基础地址
//const BASE_URL = ENV === DEV ? 'http://localhost：8081' : 'http://ob.aivmcloud.com'

const BASE_URL = ENV === DEV ? 'http://ir.aivmcloud.com' : protocol+'//'+HOST
// 接口地址
const API_URL = BASE_URL + '/api'

// 分页大小
const PAGE_SIZE = 20


// 网站标题
const API_ACTION_EXT = '.action'

const PAYFeeTag = "￥"

export default {
  PAYFeeTag,
  BASE_URL,
  API_URL,
  PAGE_SIZE,
  API_ACTION_EXT
}



// WEBPACK FOOTER //
// ./src/configs/index.js